import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { GroupsService } from '../../../../services/groups.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { EditCreateGroupsComponent } from './edit-create-groups/edit-create-groups.component';
import { ConfigGroupsComponent } from './config-groups/config-groups.component';
import { Router } from '@angular/router';
import { ControlService } from '../../../../services/control.service';
import { CustomersService } from '../../../../services/customers.service';
import { RemotebashComponent } from '../../../../shared/modal/remotebash/remotebash.component';

@Component({
	selector: 'app-groups',
	templateUrl: './groups.component.html',
	styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit, OnDestroy {

	dtConfig = {
		config: {
			base: this.groupsService,
			api: 'datatable',
			rowsPerPage: 10,
			order: [[2, 'desc']],
			params: {
				key: '',
				client_id: null
			}, hasCustomProcessData: true,
			processValues: (response) => {
				response.data.map((unit: any) => {
					unit.client_name = this.clientesMap.get(unit.client_id) || 'Cliente no asociado';
					return unit;
				});
				return response;
			}

		},
		columns: [
			{
				title: 'ID',
				field: 'id'
			},
			{
				title: 'Nombre',
				field: 'name'
			},
			{
				title: 'Unidades Asignadas',
				field: 'unitss_count'
			},
			{
				title: 'Partner',
				field: 'client_name'
			},
			{
				title: 'Numero Layouts',
				field: 'number_layouts'
			},
			{
				title: 'Activo',
				field: 'active',
			}
		],
		actions: [

		]
	};

	size: string = 'sm';
	isAdmin: boolean = false;
	clientes: any[] = [];
	selectedClientId: number | null = null;
	canAddGroup: boolean = true;

	private atComponentDestroy = new Subject();
	private clientesMap = new Map<number, string>();

	constructor(
		public modalRef: BsModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcast: BroadcastService,
		private nrModal: NRModalService,
		private swal: SwalService,
		private groupsService: GroupsService,
		private router: Router,
		private controlService: ControlService,
		private customerService: CustomersService
	) { }
clearClientFilter(): void {
		this.selectedClientId = null;
		delete this.dtConfig.config.params.client_id;
		this.broadcast.reloadDataTable();
	}
	onClientChange(): void {
		if (this.selectedClientId) {
			this.dtConfig.config.params.client_id = this.selectedClientId;
		} else {
			delete this.dtConfig.config.params.client_id;
		}
		this.broadcast.reloadDataTable();
	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next(true);
		this.atComponentDestroy.unsubscribe();
	}

	ngOnInit(): void {
		this.controlService.isAdmin().subscribe(res => {
			this.isAdmin = res.is_admin;
			this.customerService.datatable(1, {}).subscribe((res: any) => {
				if (res?.data) {
					res.data.forEach(cliente => {
						this.clientesMap.set(cliente.id, cliente.nombre_comercial ?? cliente.name);
					});
					this.broadcast.reloadDataTable();
				}
			});
			this.dtConfig.actions = this.isAdmin
				? [
					{ display: 'Flujo de contenido', icon: 'pi pi-video', event: 'groups.reels', conditionality: 'true' },
					{ display: 'Configurar', icon: 'fa-cogs', event: 'groups.config', conditionality: 'true' },
					{ display: 'Editar', icon: 'fa-pencil', event: 'groups.edit', conditionality: 'true' },
					{ display: 'Eliminar', icon: 'fa-trash', event: 'groups.delete', conditionality: 'true' },
					// { display: 'Bash', icon: 'fa-terminal', event: 'unitss.bash', conditionality: 'true' }
				]
				: [
					{ display: 'Flujo de contenido', icon: 'pi pi-video', event: 'groups.reels', conditionality: 'true' },
					{ display: 'Configurar', icon: 'fa-cogs', event: 'groups.config', conditionality: 'true' },
					{ display: 'Editar', icon: 'fa-pencil', event: 'groups.edit', conditionality: 'true' },
					{ display: 'Eliminar', icon: 'fa-trash', event: 'groups.delete', conditionality: 'true' },
				];

			this.broadcast
				.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe((event: EventModel) => {
					const props = this.prepareProps(event);
					if (props) {
						this.nrModal.open(props, this.size);
					}
				});
		});
		this.customerService.datatable(1, {}).subscribe((res: any) => {
			if (res?.data) {
				this.clientes = res.data;
				res.data.forEach(cliente => {
					this.clientesMap.set(cliente.id, cliente.nombre_comercial ?? cliente.name);
				});
				this.broadcast.reloadDataTable();
			}
		});

		this.customerService.getLimits().then((res: any) => {
			const groupLimit = res.groups || { used: 0, limit: 0 };
			this.canAddGroup = groupLimit.used < groupLimit.limit;

		});
	}

	/**
	 * Prepare the Groups data for the modal window
	 * @param event
	 * @returns
	 */
	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel;
		props.instantiated = false;
		this.size = 'lg';
		event.data.item = event.data.item || {};
		const channel = event.data.item.id || "";
		event.data.item.channel = channel.toString() || "";
		event.data.item.actions = [
			{label: "Actualizar Medias", command: "updateMediaReel"}, // Reiniciar el modulo
			{label: "Actualizar Metricas", command: "updateMediaViews"}, // Reiniciar el modulo
			{label: "Actualizar Grupos", command: "updateGroup"}, // Reiniciar el modulo
			{label: "Actualizar Group Layout", command: "updateGroupLayout"}, //Eliminar videos, evidencias
			{label: "Actualizar Reel Layout", command: "updateReelLayout"}, //Eliminar videos, evidencias
			{label: "Reiniciar APP", command: "reload"} // Recepción de todos los perifericos
		]
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {}
		};

		switch (event.name) {
			case 'groups.add':
				props.modalModel.component = EditCreateGroupsComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Grupo'
				};
				props.modalModel.data = { is_admin: this.isAdmin };
				break;

			case 'groups.edit':
				props.modalModel.component = EditCreateGroupsComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Grupo'
				};
				props.modalModel.data = {
					is_admin: this.isAdmin,
					...event.data.item
				};
				break;


			case 'groups.config':
				this.size = 'xl';
				props.modalModel.component = ConfigGroupsComponent;
				props.modalModel.modalConfiguration = {
					title: 'Configurar Grupo'
				};
				break;
			case 'unitss.bash':
							props.modalModel.component = RemotebashComponent;
							props.modalModel.modalConfiguration = {
								title: 'Conexión'
							};
							break;
			case 'groups.reels':
				this.router.navigate(['/client/config/design-reels/' + event.data.item.id]);
				return false;
			case 'groups.delete':
				this.delete(event.data);
				return false;
			default:
				return false;
		}

		return props;
	}

	/**
	 * Open the modal window for ADD
	 */
	add(): void {
		this.broadcast.fire({
			name: 'groups.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 * Get User confirmation for delete and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: '¿Estás seguro de querer eliminarlo?'
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.groupsService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Grupo eliminado exitosamente' }).then(() => {
							this.modalRef.hide(0);
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el Grupo');
					}
				});
			}
		});
	}
}
